import { createAppSlice } from '../../app/createAppSlice'

const initialState = { colorPattern: "red-green" };

const colorSchemeSlice = createAppSlice({
    name: "colorScheme",
    initialState,
    reducers: create => ({
        changeColorScheme: create.reducer((state, action) => {
            state.colorPattern = action.payload
        })
    }),
    selectors: {
        selectColorScheme: colorScheme => colorScheme.colorPattern
    },
})

export const { changeColorScheme } = colorSchemeSlice.actions

export const { selectColorScheme } = colorSchemeSlice.selectors

export default colorSchemeSlice